"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get1DColor = void 0;
const generateColor_1 = require("../../utilities/generateColor");
function get1DColor(options, usedColors, regenerate = false) {
    let color = 'black';
    if (options?.display?.color === undefined || regenerate) {
        color = (0, generateColor_1.generateColor)(false, usedColors['1d'] || []);
    }
    else {
        color = options.display.color;
    }
    if (usedColors['1d']) {
        usedColors['1d'].push(color);
    }
    return { color };
}
exports.get1DColor = get1DColor;
